import { z } from 'zod';

// Enumerated domain types, aligned with the PostgreSQL enums (modele-donnees).

export const roleUtilisateur = z.enum(['conseiller', 'administrateur', 'conformite', 'direction']);
export type RoleUtilisateur = z.infer<typeof roleUtilisateur>;

export const statutKyc = z.enum(['a_jour', 'a_renouveler', 'expire']);
export type StatutKyc = z.infer<typeof statutKyc>;

export const codeScenario = z.enum(['prudent', 'equilibre', 'dynamique']);
export type CodeScenario = z.infer<typeof codeScenario>;

export const typeEcheance = z.enum([
  'versement_initial',
  'versement_mensuel',
  'versement_exceptionnel',
  'arbitrage',
]);
export type TypeEcheance = z.infer<typeof typeEcheance>;

export const statutEcheance = z.enum(['planifie', 'en_cours', 'valide', 'rejete', 'annule']);
export type StatutEcheance = z.infer<typeof statutEcheance>;

export const statutSimulation = z.enum(['brouillon', 'active', 'archivee']);
export type StatutSimulation = z.infer<typeof statutSimulation>;

export const classeActif = z.enum(['actions', 'obligations', 'fonds_euros', 'liquidites']);
export type ClasseActif = z.infer<typeof classeActif>;

/** Allowed échéance transitions (RG-11 state machine). */
export const actionTransition = z.enum(['valider', 'annuler', 'rejeter', 'replanifier']);
export type ActionTransition = z.infer<typeof actionTransition>;
